import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { HttpParams } from '@angular/common/http';
import { RoleService } from '../../../core/services/role.service';



@Component({
  selector: 'app-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss'],
  standalone: false
})
export class EmployeesComponent implements OnInit {
  employees: any[] = [];
  filteredEmployees: any[] = [];
  loading: boolean = false;
  error: string = '';
  
  departments: any[] = [];
  fireStation: any[] = [];
  designations: any[] = [];
  shifts: any[] = [];
  managers: any[] = [];
  roles: any[] = [];
  
  currentPage: number = 1;
  totalPages: number = 1;
  totalRecords: number = 0;
  perPage: number = 20;
  
  filters = {
    fire_station_id: '',
    search: '',
    department_id: '',
    designation_id: '',
    shift_id: '',
    is_active: '',
    is_face_registered: '',
    role_id: ''
  };

  showForm: boolean = false;
  formMode: 'create' | 'edit' | 'view' = 'create';
  selectedEmployee: any | null = null;
  showPassword: boolean = false;

  employeeForm: any = this.getEmptyEmployee();

  // showBiometricModal: boolean = false;
  // biometricData: any = null;
  // selectedFiles: File[] = [];
  
  Math = Math;

  constructor(private apiService: ApiService ,public roleService: RoleService,) { }

  ngOnInit(): void {
    this.loadDropdowns();
    this.loadEmployees();
  }

  get pages(): number[] {
    const maxPages = 5;
    const pages: number[] = [];
    let startPage = Math.max(1, this.currentPage - Math.floor(maxPages / 2));
    let endPage = Math.min(this.totalPages, startPage + maxPages - 1);

    if (endPage - startPage < maxPages - 1) {
      startPage = Math.max(1, endPage - maxPages + 1);
    }

    for (let page = startPage; page <= endPage; page++) {
      pages.push(page);
    }

    return pages;
  }

  getEmptyEmployee(): any {
    return {
      fullName: '',
      email: '',
      mobileNo: '',
      password: "",
      roleId:'' ,
      designationId: '',
      fireStationId: '',
      reportingManagerId: '',
      isActive: true,
      dateOfJoining: '',
    };
  }

  loadDropdowns(): void {
    
    this.apiService.get('/employees').subscribe({
      next: (response: any) => {
        if (response.success) {
          this.managers = response.data || [];
        }
      },
      error: (err) => console.error('Failed to load managers:', err)
    });

    this.apiService.get('/fire-stations').subscribe({
      next: (response: any) => {
        if (response.success) {
          this.fireStation = response.data || [];
        }
      },
      error: (err) => console.error('Failed to load fire stations:', err)
    });

      this.apiService.get('/employees/roles').subscribe({
      next: (response: any) => {
        if (response.success) {
          this.roles = response.data || [];
        }
      },
      error: (err) => console.error('Failed to load roles:', err)
    });
  }

  loadEmployees(): void {
    this.loading = true;
    this.error = '';
    
    let params = new HttpParams()
      .set('page', (this.currentPage || 1).toString())
      .set('limit', (this.perPage || 20).toString());
    
    Object.keys(this.filters).forEach(key => {
      const value = (this.filters as any)[key];
      if (value !== '' && value !== null && value !== undefined) {
        params = params.set(key, String(value));
      }
    });
    
    this.apiService.get('/employees', params).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.employees = response.data || [];
          this.filteredEmployees = this.employees;
          
          if (response.meta) {
            this.currentPage = response.meta.currentPage || response.meta.current_page || 1;
            this.totalPages = response.meta.lastPage || response.meta.last_page || Math.ceil((response.meta.total || 0) / (response.meta.perPage || response.meta.per_page || this.perPage)) || 1;
            this.totalRecords = response.meta.total || 0;
            this.perPage = response.meta.perPage || response.meta.per_page || this.perPage;
          } else {
            this.totalRecords = this.employees.length;
            this.totalPages = Math.max(1, Math.ceil(this.totalRecords / this.perPage));
          }
        } else {
          this.error = 'Failed to load employees';
        }
        this.loading = false;
      },
      error: (err: any) => {
        this.error = err || 'Failed to load employees';
        this.loading = false;
      }
    });
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.loadEmployees();
  }

  clearFilters(): void {
    this.filters = {
      search: '',
      department_id: '',
      designation_id: '',
      shift_id: '',
      is_active: '',
      is_face_registered: '',
      fire_station_id: '',
      role_id:''
    };
    this.currentPage = 1;
    this.loadEmployees();
  }

  onPageChange(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.loadEmployees();
    }
  }

  openCreateModal(): void {
    this.formMode = 'create';
    this.employeeForm = this.getEmptyEmployee();
    this.selectedEmployee = null;
    this.showPassword = false;
    this.showForm = true;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  openEditModal(employee:any): void {
    this.formMode = 'edit';
    this.selectedEmployee = employee;
    this.employeeForm = { ...employee };
    this.showPassword = false;
    this.showForm = true;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  openViewModal(employee:any): void {
    this.formMode = 'view';
    this.selectedEmployee = employee;
    this.showForm = true;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  closeForm(): void {
    this.showForm = false;
    this.showPassword = false;
    this.selectedEmployee = null;
    this.employeeForm = this.getEmptyEmployee();
  }

  saveEmployee(): void {
    if (this.formMode === 'create') {
      this.createEmployee();
    } else if (this.formMode === 'edit') {
      this.updateEmployee();
    }
  }

  createEmployee(): void {
    this.loading = true;
    this.error = '';
    
    this.apiService.post('/employees', this.employeeForm).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.closeForm();
          this.loadEmployees();
        } else {
          this.error = response.message || 'Failed to create employee';
        }
        this.loading = false;
      },
      error: (err) => {
        this.error = err || 'Failed to create employee';
        this.loading = false;
      }
    });
  }

  updateEmployee(): void {
    if (!this.selectedEmployee?.id) return;
    
    this.loading = true;
    this.error = '';
    
    this.apiService.put(`/employees/${this.selectedEmployee.id}`, this.employeeForm).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.closeForm();
          this.loadEmployees();
        } else {
          this.error = response.message || 'Failed to update employee';
        }
        this.loading = false;
      },
      error: (err) => {
        this.error = err || 'Failed to update employee';
        this.loading = false;
      }
    });
  }

  deleteEmployee(employee:any): void {
    if (!employee.id) return;
    
    if (confirm(`Are you sure you want to delete ${employee.fullName}?`)) {
      this.loading = true;
      this.error = '';
      
      this.apiService.delete(`/employees/${employee.id}`).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.loadEmployees();
          } else {
            this.error = response.message || 'Failed to delete employee';
          }
          this.loading = false;
        },
        error: (err) => {
          this.error = err || 'Failed to delete employee';
          this.loading = false;
        }
      });
    }
  }

  getEmployeeName(employee: any): string {
    if (employee.fullName) return employee.fullName.trim();
    return `${employee.firstName || ''} ${employee.middleName || ''} ${employee.lastName || ''}`.replace(/\s+/g, ' ').trim();
  }

   getFireStationName(fireStationId?: number): string {
    if (!fireStationId) return 'Unknown Station';
    const station = this.fireStation.find(s => s.id === fireStationId);
    return station ? station.name : 'Unknown Station';
  }

  getDesignationName(designationId?: number): string {
    if (!designationId) return '-';
    const desig = this.designations.find(d => d.id === designationId);
    return desig ? desig.name : '-';
  }

  getShiftName(shiftId?: number): string {
    if (!shiftId) return '-';
    const shift = this.shifts.find(s => s.id === shiftId);
    return shift ? shift.name : '-';
  }
}
